import React from 'react'
import { connect } from 'react-redux'
import { registerBusiness } from '../actions'

class RegisterBusiness extends React.Component {
    constructor() {
        super()
        this.state = {
            username: '',
            password: '',
            organization_name: '',
            address: '',
            email: '',
            phone: '',
        }
    }

    handleChange2 = (evt) => {
        evt.preventDefault()
        this.setState({
            [evt.target.name]: evt.target.value,
        })
    }

    handleSubmit = (evt) => {
        evt.preventDefault()
        const { username, password, organization_name, address, email, phone } = this.state
        this.props.registerBusiness(username, password, organization_name, address, email, phone)
        this.setState({ username: '', password: '', organization_name: '', address: '', email: '', phone: '', })
        this.props.history.push('./LoginBusiness')
    }

    render() {
        const { username, password, organization_name, address, email, phone } = this.state
        return (
            <div>
                <div className='signupheader'>
                    <h1>Donor Sign Up</h1>
                    <p>Thanks for your interest!</p>
                </div>
                <form onSubmit={this.handleSubmit}>
                    <input type="text" name="organization_name" placeholder="Organization Name" value={organization_name} onChange={this.handleChange2} required /><br/>
                    <input type="text" name="phone" placeholder="Phone Number" value={phone} onChange={this.handleChange2} required /><br/>
                    <input type="text" name="email" placeholder="Email" value={email} onChange={this.handleChange2} required /><br/>
                    <input type="password" name="password" placeholder="Password" value={password} onChange={this.handleChange2} required /><br/>
                    {/*need to confirm password here*/}
                    {/*need office name here*/}
                    <input type="text" name="address" placeholder="Office Address" value={address} onChange={this.handleChange2} required /><br/>
                    
                    <input type="text" name="username" placeholder="New Username" value={username} onChange={this.handleChange2} required /><br/>
                    
                    
                    
                    <button type="submit">Sign Up</button>
                </form>
            </div>
        )
    }
}

const mapDispatchToProps = {
    registerBusiness
}

export default connect(null, mapDispatchToProps)(RegisterBusiness)